import { LoadingButton } from '@mui/lab';
import {
    Autocomplete,
    Card,
    CardContent,
    Grid,
    TextField,
    Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUpdateUserMutation } from '../../api/authApiSlice';
import Screen from '../../components/fragments/Screen';
import { setUser } from '../../store/slices/authSlice';
import { rtGetListData } from '../../store/slices/listSlice';
import errorSnackbar from '../../utils/errorSnackbar';

export default function MySpouseScreen() {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const state = useSelector((st) => st);

    const { user } = state.auth;
    const { spouses } = state.list2;

    const {
        firstName,
        surname,
        estate,
        gender,
        contact: { phoneNumber, email } = {},
        status: {
            maritalStatus,
            baptised,
            confirmed,
            salvation,
            occupation,
            education,
        } = {},
        spouse: { username } = {},
    } = user;

    const [lSpouse, setLSpouse] = useState(username);
    const [updateUserMutation, { isLoading }] = useUpdateUserMutation();

    const onSubmit = async () => {
        const { error, data } = await updateUserMutation({
            body: {
                maritalStatus: maritalStatus,
                baptised: baptised,
                confirmed: confirmed,
                salvation,
                occupation,
                education,
                spouse: lSpouse,
                firstName,
                surname,
                estate,
                gender,
                email,
                phoneNumber,
            },
            type: 'status',
        });

        errorSnackbar(error, enqueueSnackbar);

        if (data) {
            dispatch(setUser(data?.data));
            enqueueSnackbar('Profile Updated');
        }
    };

    return (
        <Screen title={'My Spouse'}>
            <Grid sx={{ mt: 0.5, width: '100%' }} item>
                <Card sx={{ mb: 2 }} variant="outlined">
                    <CardContent>
                        <Typography variant="body2" color="GrayText">
                            Current Spouse
                        </Typography>
                        <Typography>{username || 'None'} </Typography>
                    </CardContent>
                </Card>
                <Autocomplete
                    fullWidth
                    disablePortal
                    sx={{ my: 1 }}
                    options={spouses.map((spouse) => ({
                        label: spouse.username,
                    }))}
                    value={lSpouse}
                    onChange={(e, val) => setLSpouse(val)}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            onChange={(e) => {
                                dispatch(
                                    rtGetListData(
                                        `members?username=${e.target.value}`,
                                        'spouses'
                                    )
                                );
                            }}
                            placeholder="PLCHLD"
                            label="Spouse"
                        />
                    )}
                />

                <div className="d-flex align-items-center justify-content-end">
                    <LoadingButton
                        loading={isLoading}
                        onClick={onSubmit}
                        variant="contained"
                    >
                        Update Spouse
                    </LoadingButton>
                </div>
            </Grid>
        </Screen>
    );
}
